import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import { Formik } from 'formik';
import { withStore } from 'store';
import {
  addShoppingCartProduct,
  removeShoppingCartProduct,
  fetchShoppingCart,
} from 'store/actions/externalGiftTable';
import { showErrorResponseModal } from 'store/actions/commons';
import { GiftItem } from 'components/gifts-table';
import { transformForListStructure } from 'util/transformHelpers';
import { mapPropsToValues } from '../GiftsList/config';
import styles from './cartPopover.module.scss';
import './styles.scss';
import { useWindowSize } from 'hooks';

const CartProducts = ({ dispatch, shoppingCartProducts = [] }) => {
  const [, { isMobile }] = useWindowSize();
  const history = useHistory();
  const { eventId } = useParams();
  const [shoppingCartLength, setShoppingCartLength] = useState(
    shoppingCartProducts.length
  );

  const handleAddProduct = async (product) => {
    const response = await dispatch(addShoppingCartProduct(product));
    console.log('handleAddProduct', response);
    !response && dispatch(fetchShoppingCart({ tableId: eventId }));
    !response && dispatch(showErrorResponseModal('Intenta más tarde'));
    return response;
  };

  const handleDeleteProduct = async (product) => {
    const response = await dispatch(removeShoppingCartProduct(product));
    !response && dispatch(fetchShoppingCart({ tableId: eventId }));
    !response && dispatch(showErrorResponseModal('Intenta más tarde'));
    return response;
  };

  const handleBuyNow = () => {
    if (eventId) {
      history.push(`/buy-gifts/${eventId}/buy`);
    }
  };

  const initialValues = useMemo(
    () => mapPropsToValues(transformForListStructure(shoppingCartProducts)),
    [shoppingCartProducts]
  );

  useEffect(() => {
    if (shoppingCartProducts.length > shoppingCartLength) {
      document.getElementsByClassName(styles.productsRow)[0].scrollTo(0, 0);
    }
    setShoppingCartLength(shoppingCartProducts.length);
  }, [shoppingCartProducts]);

  return (
    <Formik initialValues={initialValues}>
      <>
        <Row className={`${styles.productsRow} m-2`}>
          {shoppingCartProducts.map((product) => (
            <Col key={product.id} xs={12} className="px-0">
              <GiftItem
                id={product.id}
                onAddGift={handleAddProduct}
                onUpdateGift={handleAddProduct}
                onDeleteGift={handleDeleteProduct}
                type="list"
                showBigPrice={false}
                showRating={false}
                item={product}
                selected
                quantity={product?.quantity || 1}
                mode="guest"
                listClassName='border-1'
                className="mb-1"
                callFrom = {isMobile?'CartProductsMobile':''}
                showBack
              />
            </Col>
          ))}
        </Row>
        <Row>
          {shoppingCartProducts.length === 0 ? (
            <Col xs={12}>
              <h4 className="text-center mt-1">No has agregado productos </h4>
            </Col>
          ) : (
            <Col xs={12} className="my-4">
              <Button
                onClick={handleBuyNow}
                block
                className={`${styles.buyButton} m-auto`}
              >
                Comprar ahora
              </Button>
            </Col>
          )}
        </Row>
      </>
    </Formik>
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
    externalGiftTableProducts:
      state.externalGiftTable.externalGiftTableProducts,
  }),
})(CartProducts);
